import {OptionPricingGridMode} from "../options-pricing-grid-base.component";

export type ToolbarRow = 'top' | 'bottom';

export interface ToolbarElementDescriptor {
    readonly key: string;
    readonly label: string;
    readonly modes: ReadonlyArray<OptionPricingGridMode>;
    readonly row: ToolbarRow;
}

export const TOOLBAR_ELEMENT_CATALOG: ReadonlyArray<ToolbarElementDescriptor> = [
    {key: 'underlying',        label: 'Underlying',      modes: ['opg', 'pmd'], row: 'top'},
    {key: 'expiration',        label: 'Expiration',      modes: ['opg', 'pmd'], row: 'top'},
    {key: 'strike-step',       label: 'Strike Step',     modes: ['opg', 'pmd'], row: 'top'},
    {key: 'atm-strike',        label: 'ATM Strike',      modes: ['opg', 'pmd'], row: 'top'},
    {key: 'num-of-strikes',    label: '# of Strikes',    modes: ['opg', 'pmd'], row: 'top'},
    {key: 'call-offset',       label: 'Call Offset',     modes: ['opg', 'pmd'], row: 'top'},
    {key: 'call-range',        label: 'Call Range',      modes: ['opg', 'pmd'], row: 'top'},
    {key: 'put-offset',        label: 'Put Offset',      modes: ['opg', 'pmd'], row: 'top'},
    {key: 'put-range',         label: 'Put Range',       modes: ['opg', 'pmd'], row: 'top'},
    {key: 'percentage-profit', label: '% - Profit',      modes: ['opg'],        row: 'top'},
    {key: 'r-multiple',        label: 'R Multiple',      modes: ['opg'],        row: 'top'},
    {key: 'itm-data',          label: 'ITM Data',        modes: ['opg', 'pmd'], row: 'top'},

    {key: 'default-qty',       label: 'Default Qty',     modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'hedge-mode',        label: 'Hedge Mode',      modes: ['opg', 'pmd'], row: 'bottom'},
    // key stays 'auto-size' -- it is the persisted user-settings identifier
    // (opg-toolbar-visibility.<mode>.auto-size). Only the display label changed.
    {key: 'auto-size',         label: 'Auto-Scroll',     modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'pnl',               label: 'P&L',             modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'total-pnl',         label: 'Total P&L',       modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'prop-to-puts',      label: 'Prop. To Puts',   modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'custom-range',      label: 'Custom Range',    modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'prop-to-calls',     label: 'Prop. To Calls',  modes: ['opg', 'pmd'], row: 'bottom'},
    {key: 'pricing-mode',      label: 'Pricing Mode',    modes: ['opg'],        row: 'bottom'},
    // 'iv-box' and 'h-skew' were removed 2026-07-02 (owner): both readings moved from the
    // toolbar to the CALLS/PUTS side-panel headers and are no longer toggleable. Stale
    // persisted visibility keys are ignored by the manager.
];

